mutation updateCompanyAmbassadorSignatureExtra(
  $input: UpdateCompanyAmbassadorSignatureExtraInput!
) {
  updateCompanyAmbassadorSignatureExtra(input: $input)
}
